(ns frontend.test.new-buttons
  (:require
   [frontend.routing :as routing]
   [ui.components.button.view :refer [button]]
   [basic-components.tooltip :as tooltip]
   [basic-components.popover :as popover]))


(def variants
  [{:variant :text
    :label   "Text"}
   {:variant :contained
    :label   "Contained"}
   {:variant :outlined
    :label   "Outlined"}])

(defn button-variants
  []
  [:div
   {:class "flex gap-3"}
   (->> variants
        (map (fn [{:keys [variant label]}]
               (let []
                 ^{:key (str "btn-var-" variant)}
                 [button
                  {:variant variant}
                  label]))))])

(defn button-sizes
  []
  [:div
   {:class "flex gap-3"}
   (->> [{:size  :small
          :label "Small"}
         {:size  :medium
          :label "Medium"}
         {:size  :large
          :label "Large"}]
        (map (fn [{:keys [size label]}]
               ^{:key (str "btn-" size)}
               [button
                {:size    size
                 :variant :contained}
                label])))])

(defmethod routing/render-view :test/new-buttons
  [{:keys [route-params]}]
  (let []
    [:div.container.bg-white.scroll.pb-5
     [:h1.title-h1.mb-4 "Buttons"]
     [:h2.title-h2.mb-2 "Variants"]
     [button-variants]
     [:h2.title-h2.mb-2 "Sizes"]
     [button-sizes]]))
